<div
  class="flex flex-col justify-center items-center w-full h-scree overflow-hidden bg-[#f2f2f2ff]"
>
  <div
    *ngIf="loginMessage"
    class="w-[300] mt-2 alert alert-{{ loginMessageType }}"
    role="alert"
  >
    {{ loginMessage }}
  </div>
  <div
    class="flex justify-center items-center w-[400px] h-[440px] m-[20px] bg-[#fff] p-[24px] shadow-md rounded-[4px]"
  >
    <div
      class="flex flex-col justify-center items-center gap-8 w-[285px] h-[326px]"
    >
      <div class="flex flex-col justify-between items-start gap-2 w-full">
        <h1 class="text-[30px] font-[400]">Log in to Easy Power</h1>
        <p class="text-[12px] font-[400]">Enter your details below</p>
      </div>

      <form
        action=""
        class="w-full"
        [formGroup]="loginForm"
        (ngSubmit)="onSubmit()"
      >
        <div class="mb-6">
          <input
            type="text"
            name="email"
            placeholder="Email or phone number"
            class="w-full border-b-[1px] border-gray-400 py-[6px] focus:px-[6px]"
            formControlName="email"
            required
          />
        </div>
        <div class="mb-6">
          <input
            type="password"
            name="password"
            placeholder="Password"
            class="w-full border-b-[1px] border-gray-400 py-[6px] focus:px-[6px]"
            formControlName="password"
            required
          />
        </div>
        <div class="w-full flex justify-between items-center">
          <!--          <button-->
          <!--            class="flex justify-center items-center w-[100px] h-[40px] rounded-[4px] bg-[#FFBA49] text-[#fff] text-[12px]"-->
          <!--          >-->
          <!--            Log in-->
          <!--          </button>-->

          <h1 class="text-[14px] text-Poppins font-[400]">Forgot Password?</h1>
        </div>
      </form>
    </div>
  </div>
  <!--  <footer-->
  <!--    class="max-sm:hidden flex flex-col justify-between items-center w-full h-[280px] bg-[#061233] text-[#FAFAFA]"-->
  <!--  >-->
  <!--    <div class="flex justify-evenly items-start w-full p-4 text-[12px] font-[400]">-->
  <!--      <div class="flex flex-col gap-4">-->
  <!--        <div class="flex flex-col gap-6 font-Poppins">-->
  <!--          <h3 class="font-Inter text-2xl font-bold">Easy Power Hub</h3>-->
  <!--          <p class=" text-[20px] font-[400]">Subscribe</p>-->
  <!--          <p class="text-[12px] font-[400]">Get 10% off your first order</p>-->
  <!--        </div>-->
  <!--        <div-->
  <!--          class="flex border-2 border-[#FAFAFA] min-w-fit p-3 rounded md:justify-between sm:justify-between xs:justify-between"-->
  <!--        >-->
  <!--          <input-->
  <!--            type="email"-->
  <!--            placeholder="Enter your email"-->
  <!--            class="bg-inherit outline-none"-->
  <!--          />-->
  <!--          <img src="assets/icons/send-icon.png" alt="" />-->
  <!--        </div>-->
  <!--      </div>-->
  <!--      <div class="font-Poppins flex flex-col gap-4 text-[12px] font-[400]">-->
  <!--        <h6 class="font-[400] text-[20px] mb-2">Support</h6>-->
  <!--        <p>111 Locationi, Dhaka</p>-->
  <!--        <p>DH 1515, Location.</p>-->
  <!--        <p>example&#64;gmail.com</p>-->
  <!--        <p>+23481-88888-9999</p>-->
  <!--      </div>-->
  <!--      <div class="font-Poppins flex flex-col gap-4 text-[12px] font-[400]">-->
  <!--        <h6 class="font-[400] text-[20px] mb-2">Account</h6>-->
  <!--        <a>My account</a>-->
  <!--        <a>Login / Register</a>-->
  <!--        <a>Cart</a>-->
  <!--        <a>Services</a>-->
  <!--        <a>Shop</a>-->
  <!--      </div>-->
  <!--      <div class="font-Poppins flex flex-col gap-4 text-[12px] font-[400]">-->
  <!--        <h6 class="font-[400] text-[20px] mb-2">Quick Link</h6>-->
  <!--        <a>Privacy Policy</a>-->
  <!--        <a>Terms of Use</a>-->
  <!--        <a>FAQ</a>-->
  <!--        <a>Contact</a>-->
  <!--      </div>-->

  <!--      <div class="font-Poppins flex flex-col gap-4">-->
  <!--        <h6 class="font-[400] text-[20px] mb-2">Download App</h6>-->
  <!--        <p class="text-xs font-medium opacity-70">-->
  <!--          Save $3 with App New User Only-->
  <!--        </p>-->
  <!--        <div class="flex gap-2">-->
  <!--          <img src="assets/icons/Qr Code.png" alt="" />-->
  <!--          <div class="flex flex-col justify-center items-center gap-1">-->
  <!--            <img src="assets/icons/GooglePlay.png" alt="" />-->
  <!--            <img src="assets/icons/AppStore.png" alt="" />-->
  <!--          </div>-->
  <!--        </div>-->
  <!--        <div class="flex gap-8 items-center">-->
  <!--          <a href="">-->
  <!--            <img src="assets/icons/Icon-Facebook.png" alt="" />-->
  <!--          </a>-->
  <!--          <a href="#">-->
  <!--            <img src="assets/icons/Icon-Twitter.png" alt="" />-->
  <!--          </a>-->
  <!--          <a href="">-->
  <!--            <img src="assets/icons/icon-instagram.png" alt="" />-->
  <!--          </a>-->
  <!--        </div>-->
  <!--      </div>-->
  <!--    </div>-->
  <!--    <div-->
  <!--      class="w-full font-Poppins xl:text-base lg:text-base text-sm text-[#FFFFFF] text-center pb-3 pt-1 border-t opacity-40"-->
  <!--    >-->
  <!--      <p>&#169; Copyright Easy power hub 2024. All right reserved</p>-->
  <!--    </div>-->
  <!--  </footer>-->
</div>

<!--Email: superadmin@super.com-->
<!--Password: securePassword123-->
